import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { TextField, Button, Box, CircularProgress } from "@mui/material";

const ProfileForm = ({ disabled, data, onSubmit, isLoading }) => {
    const { register, handleSubmit, reset } = useForm({
        defaultValues: {
            marital_status: data?.marital_status || '',
            occupation: data?.occupation || '',
            family_details: data?.family_details || '',
            current_situation: data?.current_situation || '',
            personalized_prediction: data?.personalized_prediction || '',
            user_notes: data?.user_notes || '',
        },
    });

    useEffect(() => {
        reset({
            marital_status: data?.marital_status || '',
            occupation: data?.occupation || '',
            family_details: data?.family_details || '',
            current_situation: data?.current_situation || '',
            personalized_prediction: data?.personalized_prediction || '',
            user_notes: data?.user_notes || '',
        });
    }, [data])

    const submitHandler = (values) => onSubmit?.(values);

    return (
        <Box className="w-full">
            {isLoading && (
                <Box
                    className="absolute inset-0 z-10 flex items-center justify-center"
                    sx={{
                        backgroundColor: "rgba(255, 255, 255, 0.6)",
                        backdropFilter: "blur(2px)",
                    }}
                >
                    <CircularProgress />
                </Box>
            )}
            <form onSubmit={handleSubmit(submitHandler)} className="space-y-6">

                {/* GRID */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <TextField
                        label="Relationship Status"
                        id="relationship_status"
                        fullWidth
                        multiline
                        {...register("marital_status")}
                        InputLabelProps={{ shrink: true }}
                        disabled={disabled}
                        minRows={2}
                        maxRows={4}
                    />

                    <TextField
                        label="Family Details"
                        fullWidth
                        multiline
                        {...register("family_details")}
                        InputLabelProps={{ shrink: true }}
                        disabled={disabled}
                        minRows={2}
                        maxRows={4}
                    />

                    <TextField
                        label="Occupation"
                        fullWidth
                        multiline
                        {...register("occupation")}
                        InputLabelProps={{ shrink: true }}
                        disabled={disabled}
                        minRows={2}
                        maxRows={4}
                    />

                    <TextField
                        label="Current Situation"
                        fullWidth
                        multiline
                        {...register("current_situation")}
                        InputLabelProps={{ shrink: true }}
                        disabled={disabled}
                        minRows={2}
                        maxRows={4}
                    />

                    <TextField
                        label="User Notes"
                        fullWidth
                        multiline
                        {...register("user_notes")}
                        disabled={disabled}
                        InputLabelProps={{ shrink: true }}
                        minRows={2}
                        maxRows={4}
                    />

                    <TextField
                        label="Personalized Info"
                        fullWidth
                        multiline
                        {...register("personalized_prediction")}
                        disabled={disabled}
                        InputLabelProps={{ shrink: true }}
                        minRows={2}
                        maxRows={4}
                    />
                </div>

                {/* Save Button — ONLY visible in edit mode */}
                <Button
                    variant="contained"
                    fullWidth
                    type="submit"
                    disabled={disabled || isLoading}
                >
                    {isLoading ? "Saving..." : "Save"}
                </Button>
            </form>
        </Box>
    );
};

export default ProfileForm;
